export class Meeting {
  id: number;
  startTime: Date;
  endTime: Date;
  client: string;
  contact: string;
  purpose: string;
  numberOfPeople: number;
  unit: string;
  unitDescription: string;
  clientDescription: string;
}